import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const rooms = [
  {
    title: 'Bedroom',
    sub: 'Beds, mattresses & wardrobes',
    cat: 'bed',
    image:
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&q=80',
  },
  {
    title: 'Living',
    sub: 'Sofas, lounges & TV units',
    cat: 'lou',
    image:
      'https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=1200&q=80',
  },
  {
    title: 'Dining',
    sub: 'Tables & chair sets',
    cat: 'tab',
    image:
      'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&q=80',
  },
  {
    title: 'Workspace',
    sub: 'Desks & office chairs',
    cat: 'desk',
    image:
      'https://images.unsplash.com/photo-1593062096033-9a26b09da705?w=1200&q=80',
  },
];

const RoomLookbook = () => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-[#f7f5f1]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
            Shop by Room
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black tracking-tight font-display-serif mb-4">
            Style every space
          </h2>
          <p className="text-base md:text-lg text-gray-600">
            From restful bedrooms to inviting living areas — find pieces curated for the way you live.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {rooms.map((room, idx) => (
            <Link
              key={idx}
              to={`/furniture#${room.cat}`}
              className="group relative block aspect-[3/4] rounded-2xl overflow-hidden bg-gray-200"
            >
              <img
                src={room.image}
                alt={room.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <p className="text-white/80 text-[10px] md:text-xs uppercase tracking-[0.2em] mb-1.5">
                  {room.sub}
                </p>
                <div className="flex items-end justify-between gap-3">
                  <h3 className="text-2xl md:text-3xl font-medium text-white font-display-serif tracking-tight leading-none">
                    {room.title}
                  </h3>
                  <span className="flex items-center text-white opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomLookbook;
